import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router'

import Test from '../../pages/Test'

const TestRoute = () => {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <Route path={path} component={Test} />
    </Switch>
  )
}

export default TestRoute
